// extracted by mini-css-extract-plugin
export default {"content":"profile_completion-module___content___d7a4791a"};